const sanitize = (v) => Math.round(v * 1e5) / 1e5;
export {
  sanitize
};
